var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video-player',{ref:"videoPlayer",staticClass:"game-video",class:{'revealed' : _vm.isRevealed},on:{"error":function($event){return _vm.$emit('error')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }